// src/pages/Login.js
import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("로그인 성공!");
      navigate("/"); // 로그인 후 메인 페이지로 이동
    } catch (err) {
      setError("이메일 또는 비밀번호가 올바르지 않습니다.");
    }
  };

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-neutral-800 rounded-lg p-8 shadow-lg shadow-neutral-700">
        {/* 로고 이미지 (클릭 시 홈으로) */}
        <div className="flex justify-center mb-8">
          <Link to="/">
            <img
              src="/images/logo/logo_main1.png"
              alt="STOVE Logo"
              className="h-20 object-contain"
            />
          </Link>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-300">
              아이디 (이메일)
            </label>
            <input
              id="email"
              type="email"
              placeholder="이메일 주소"
              className="mt-1 w-full border border-neutral-300 rounded-md px-3 py-2 "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-300">
              비밀번호
            </label>
            <input
              id="password"
              type="password"
              placeholder="비밀번호"
              className="mt-1 w-full border border-gray-300 rounded-md px-3 py-2 "
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="text-red-600 text-sm">{error}</p>}

          <button
            type="submit"
            className="w-full bg-red-600 text-white font-semibold py-2 rounded-md hover:bg-red-700 transition"
          >
            로그인
          </button>
        </form>

        <div className="mt-4 flex justify-end text-sm text-gray-300">
          <Link to="/signup" className="hover:underline">
            회원가입
          </Link>
        </div>
      </div>
    </div>
  );
}